import { FLOW_STATUS_APPROVED } from "../../../../../../../store/File/constants";

export const deactivated = (status, isIndexing) => {
  if (status === FLOW_STATUS_APPROVED && !isIndexing) {
    return true;
  }
  return false;
};
